/**
 * The apothecary's west-wall pieces (lifted from lantern-water's `world.js`
 * `createShop`): the framed botanical plate (`art.ts` `botanicalTexture`, its
 * captions as ruled lines) with the writing shelf beneath it, and the round
 * wall clock (`art.ts` `clockTexture`, hour ticks for numerals) on its
 * bracket. A once-built piece: origin at the room's centre on the floor. No
 * params.
 */
import * as THREE from 'three';
import { botanicalTexture, clockTexture } from '../art.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'shop_wall_decor',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { m, kit } = ctx;
    ctx.box(root, -6.3, 2.65, -1.65, 0.17, 2.1, 1.6, m.darkWood);
    ctx.box(root, -6.19, 2.65, -1.65, 0.06, 1.91, 1.4, m.brass);
    const plate = kit.shared('shop-wall-decor:plate', () => new THREE.MeshStandardMaterial({ map: kit.shared('shop-wall-decor:plate-map', () => botanicalTexture()), roughness: 1 }));
    const botanical = ctx.mesh(root, ctx.plane, plate, -6.15, 2.65, -1.65, 1.28, 1.79, 1);
    botanical.rotation.y = Math.PI / 2;
    ctx.box(root, -6.16, 1.39, -1.65, 0.48, 0.12, 1.7, m.wood);
    const clockCase = ctx.cylinder(root, -6.24, 3.2, 1.68, 0.48, 0.22, m.darkWood);
    clockCase.rotation.z = Math.PI / 2;
    const face = kit.shared('shop-wall-decor:clock-face', () => new THREE.MeshStandardMaterial({ map: kit.shared('shop-wall-decor:clock-map', () => clockTexture()), roughness: 1 }));
    const clockFace = ctx.mesh(root, kit.shared('shop-wall-decor:clock-disc', () => new THREE.CircleGeometry(0.42, 32)), face, -6.11, 3.2, 1.68);
    clockFace.rotation.y = Math.PI / 2;
    ctx.box(root, -6.24, 2.55, 1.68, 0.19, 0.65, 0.22, m.darkWood);
    ctx.mesh(root, ctx.sphere, m.brass, -6.11, 2.43, 1.68, 0.05, 0.11, 0.11);
    return { root };
  },
};
